module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/journey-search.component.css
// module id = ./src/app/journey-search.component.css
// module chunks = main